import LenderPageTemplate from '@/components/shared/LenderPageTemplate'

const BlueMotorFinancePage = () => {
  return (
    <LenderPageTemplate
      lenderName="Blue Motor"
      slug="/lenders/mis-sold-blue-motor-car-finance"
      seoImage=""
      seoImageAlt=""
      aiOverview=""
    />
  )
}

export default BlueMotorFinancePage
